import * as React from "react";

const Plus: React.FC = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.47949 12.5L3.47949 7.5L4.87949 6.05L7.47949 8.65V0.5H9.47949V8.65L12.0795 6.05L13.4795 7.5L8.47949 12.5ZM2.47949 16.5C1.92949 16.5 1.45866 16.3042 1.06699 15.9125C0.675326 15.5208 0.479492 15.05 0.479492 14.5V11.5H2.47949V14.5H14.4795V11.5H16.4795V14.5C16.4795 15.05 16.2837 15.5208 15.892 15.9125C15.5003 16.3042 15.0295 16.5 14.4795 16.5H2.47949Z" fill="#A22E31"/>
        </svg>
    );
};

export default React.memo(Plus);
